import styled from "styled-components";

export const SeperateLine = styled.hr`
    width: 100%;
    color: #d5d5d5;
    opacity: 0.4;
`;

export const FormContainer = styled.div`
    width: 450px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 1700px) {
        width: 35%;
    }
    @media (max-width: 1024px) {
        width: 65%;
    }
    @media (max-width: 512px) {
        width: 95%;
    }
`;

export const RowContainer = styled.div`
    display: flex;
    margin: 0 10px;
    flex-direction: row;
    justify-content: space-between;
`;

export const PageContainer = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    @media (max-width: 1024px) and (min-device-width: 1100px) {
        height: 150vh !important;
    }
    @media (max-width: 512px) and (min-device-width: 1100px) {
        height: 200vh !important;
    }
}
`;

export const BlankPage = styled.div`
    height: 100%;
    width: 100%;
    background-color: white;
}
`;
